import React from 'react';
export var MenuContext = React.createContext({
    index: '0',
    inlineIndent: 20,
    mode: 'horizontal',
});
//# sourceMappingURL=menu-context.js.map